import { call, put, all, takeEvery } from "redux-saga/effects";
import { handleApiErrors } from "../../commons/errors/apiErrors";
import { identificationTypesGetError, identificationTypesGetSuccess } from "./actions";
import { IDENTIFICATION_TYPES_GET_REQUESTING } from "./constants";

const baseUrl = `${process.env.REACT_APP_API_URL}/identificationTypes`;

const identificationTypesGetApi = () => {
	return fetch(`${baseUrl}`, {
		method: 'GET',
	})
		.then(handleApiErrors)
		.then(response => response.json())
		.then(json => {
			if (json.code === 400)
				throw [json.data];
			if (json.code === 422)
				throw json.data;
			if (json.code === 200)
				return json.data.data;
			throw json.data;
		}).catch((error) => {
			throw error;
		})
};

function* identificationTypesGetFlow() {
	try {
		const identificationTypes = yield call(identificationTypesGetApi);
		yield put(identificationTypesGetSuccess(identificationTypes));
	} catch (error) {
		yield put(identificationTypesGetError(error));
	}
}

function* identificationTypesWatcher() {
	yield all([
		takeEvery(IDENTIFICATION_TYPES_GET_REQUESTING, identificationTypesGetFlow),
	])
}

export default identificationTypesWatcher;